export const getDownloads = (state, downloads) => {
  state.downloads = downloads
}

export const setLoading = (state, value) => {
  state.loading = value;
}

export const addPendingExport = (state, { key, label }) => {
  state.pendingExports.push({
    key,
    label,
    status: 'loading',
    downloadRow: null,
    message: null,
  });
}

export const resolvePendingExport = (state, { key, downloadRow }) => {
  const item = state.pendingExports.find((e) => e.key === key);
  if (item) {
    item.status = 'done';
    item.downloadRow = downloadRow;
  }
}

export const failPendingExport = (state, { key, message }) => {
  const item = state.pendingExports.find((e) => e.key === key);
  if (item) {
    item.status = 'error';
    item.message = message;
  }
}

export const removePendingExport = (state, { key }) => {
  state.pendingExports = state.pendingExports.filter((e) => e.key !== key);
}
